"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReservedVehicleStockStatusBySerialNumberMutation = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.updateReservedVehicleStockStatusBySerialNumberMutation = `
  mutation updateReservedVehicleStockStatusBySerialNumber($serialNo: String!, $salesPersonId: String!, $dealerId: String!, $reserveForMinutes: Int) {
    updateReservedVehicleStockStatusBySerialNumber(serialNo: $serialNo, salesPersonId: $salesPersonId, dealerId: $dealerId, reserveForMinutes: $reserveForMinutes) {
      ...vehicleStock
    }
  }
  ${fragments_1.vehicleStockFragment}
`;
//# sourceMappingURL=vehicle-stock.js.map